import React from 'react';
import styled, { css } from 'styled-components';
import { lightGrey2Color, lightGrey1Color } from 'js/config/style';

const reverseChevron = css`
  transform: scaleX(-1);
`;

export default styled(({ disabled, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.67 25.09" {...rest}>
    <polyline className="chevron" points="1.06 1.06 12.54 12.54 1.06 24.03" />
  </svg>
))`
  position: relative;
  height: 1rem;
  ${({ direction }) => (direction === 'left' ? reverseChevron : null)}

  .chevron {
    fill: none;
    stroke: ${({ color, disabled }) => (color ? color : disabled ? lightGrey1Color : lightGrey2Color)};
    stroke-miterlimit: 10;
    stroke-width: 3px;
  }
`;
